import MemberDobValidationContainer from './MemberDobValidation.Container';

export default MemberDobValidationContainer;